import { useState, type ReactNode } from 'react';
import dayjs from 'dayjs';
import Button from '@liquidweb-dev/undercurrent/Button';
import DialogScheduledCancellation from 'components/DialogScheduledCancellation/DialogScheduledCancellation';
import getIsCancellationScheduled from 'components/ServersList/getIsCancellationScheduled';
import useScheduledCancellationFlag from 'components/CancellationScheduledServerList/useScheduledCancellationFlag';
import type { AssetDetails } from 'modules/queries/asset/useDetails';

export interface ActionsSlotProps {
	assetDetails: AssetDetails;
	children: ReactNode;
}

/**
 * The actions area of a server list entry. An asset with a cancellation
 * scheduled offers a way back out of it instead of its usual actions, whatever
 * those actions happen to be for its product type.
 */
const ActionsSlot = ({ assetDetails, children }: ActionsSlotProps) => {
	const isScheduledCancellationFlagEnabled = useScheduledCancellationFlag();
	const [isKeepServiceDialogOpen, setIsKeepServiceDialogOpen] = useState(false);
	const {
		domain,
		nextInvoiceDate,
		scheduledCancellationDate,
		uniq_id: uniqId,
	} = assetDetails;

	// avoid scheduled cancellation options within server listing, if flag is not set or cancellation date is not scheduled
	if (
		!isScheduledCancellationFlagEnabled ||
		!getIsCancellationScheduled(scheduledCancellationDate)
	) {
		return <>{children}</>;
	}

	return (
		<>
			<Button
				variant="secondary"
				size="medium"
				onClick={(e) => {
					e.preventDefault();
					setIsKeepServiceDialogOpen(true);
				}}
			>
				Keep my service
			</Button>

			<DialogScheduledCancellation
				open={isKeepServiceDialogOpen}
				uniqId={uniqId}
				onClose={() => setIsKeepServiceDialogOpen(false)}
				serverName={domain}
				nextRenewalDate={dayjs(nextInvoiceDate?.DateTime).format(
					'MMMM D, YYYY',
				)}
			/>
		</>
	);
};

export default ActionsSlot;
